import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const authority = import.meta.env.VITE_OIDC_AUTHORITY;

function resolveStorage(): Storage {
	try {
		window.sessionStorage.setItem('__probe__', '1');
		window.sessionStorage.removeItem('__probe__');
		return window.sessionStorage;
	} catch {
		return window.localStorage;
	}
}

function createUserManager(): UserManager | null {
	if (!authority) return null;
	try {
		return new UserManager({
			authority,
			client_id: import.meta.env.VITE_OIDC_CLIENT_ID ?? 'badminton-spa',
			redirect_uri: `${window.location.origin}/auth/callback`,
			post_logout_redirect_uri: `${window.location.origin}/`,
			scope: 'openid profile',
			silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
			automaticSilentRenew: true,
			accessTokenExpiringNotificationTimeInSeconds: 60,
			userStore: new WebStorageStateStore({ store: resolveStorage() }),
			revokeTokensOnSignout: true
		});
	} catch (err) {
		console.error('[OIDC] UserManager initialization failed:', err);
		return null;
	}
}

export const userManager: UserManager | null = createUserManager();
